module.exports = __webpack_public_path__ + "img/feyi.d3f89267.png";